import { useEffect, useRef } from 'react';
import { useGameStore } from '../store/gameStore';

/**
 * Hook for game timer
 */
export function useTimer() {
  const intervalRef = useRef<number>();
  const incrementTimer = useGameStore(state => state.incrementTimer);
  const isPaused = useGameStore(state => state.isPaused);
  const gameStatus = useGameStore(state => state.currentGame?.status);

  useEffect(() => {
    if (gameStatus === 'in_progress' && !isPaused) {
      intervalRef.current = window.setInterval(() => {
        incrementTimer();
      }, 1000);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isPaused, gameStatus, incrementTimer]);
}


